<template>
    <div>
        <rkm-form
            v-if="loaded"
            ref="Form"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="8">
                    <rkm-area
                        no-margin-top
                        title="Conteúdo do banner"
                        type="fieldset"
                    >
                        <rkm-row>
                            <rkm-col>
                                <rkm-form-input
                                    label="Título"
                                    v-model="model.titulo"
                                    :validations="validations.titulo"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-textarea
                                    label="Texto"
                                    v-model="model.texto"
                                    rows="2"
                                    max-rows="2"
                                    :validations="validations.texto"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="auto">
                                <label>Ícone</label>
                                <div class="opcoes">
                                    <button
                                        v-for="icone in icones"
                                        :key="icone.id"
                                        type="button"
                                        class="opcao-icone"
                                        :class="{ selecionado: model.icone === icone.id }"
                                        :title="icone.nome"
                                        @click="model.icone = icone.id"
                                    >
                                        <BannerIcone :icone="icone.id" />
                                    </button>
                                </div>
                            </rkm-col>

                            <rkm-col cols="auto">
                                <label>Cor</label>
                                <div class="opcoes">
                                    <button
                                        v-for="cor in cores"
                                        :key="cor.valor"
                                        type="button"
                                        class="opcao-cor"
                                        :class="{ selecionado: model.cor === cor.valor }"
                                        :style="{ background: cor.valor }"
                                        :title="cor.nome"
                                        @click="model.cor = cor.valor"
                                    />
                                </div>
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>

                    <rkm-area
                        title="Exibição"
                        type="fieldset"
                    >
                        <rkm-row>
                            <rkm-col cols="6">
                                <rkm-form-select
                                    label="Ao tocar"
                                    text-field="descricao"
                                    value-field="id"
                                    v-model="model.parametrizacaoBannerAcaoTipoId"
                                    :options="form.acaoTipos"
                                    :validations="validations.acaoTipo"
                                    show-default-option
                                />
                            </rkm-col>

                            <rkm-col
                                 v-if="model.parametrizacaoBannerAcaoTipoId  === acaoBanners.TELA_APP"
                                cols="6"
                            >
                                <rkm-form-select
                                    label="Tela do app"
                                    text-field="descricao"
                                    value-field="id"
                                    v-model="model.parametrizacaoBannerTelaId"
                                    :options="form.telas"
                                    :validations="validations.tela"
                                    show-default-option
                                />
                            </rkm-col>

                            <rkm-col
                                v-if="model.parametrizacaoBannerAcaoTipoId  === acaoBanners.LINK"
                                cols="6"
                            >
                                <rkm-form-input
                                    label="Endereço do site"
                                    placeholder="https://"
                                    v-model="model.acaoUrl"
                                    :validations="validations.acaoUrl"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="6">
                                <rkm-form-input
                                    label="Origem"
                                    placeholder="Ex.: Secretaria Municipal de Saúde"
                                    v-model="model.origem"
                                    :validations="validations.origem"
                                />
                            </rkm-col>

                           <rkm-col cols="6">
                                <rkm-form-select
                                    label="Posição no carrossel"
                                    v-model="model.ordem"
                                    :validations="validations.ordem"
                                    show-default-option>
                                    <rkm-form-select-option
                                        v-for="posicao in 4"
                                        :key="posicao"
                                        :value="posicao">
                                        {{ posicao }}º
                                    </rkm-form-select-option>
                                </rkm-form-select>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-input
                                    label="Início"
                                    type="date"
                                    v-model="model.dataInicio"
                                    :validations="validations.dataInicio"
                                />
                            </rkm-col>

                            <rkm-col>
                                <rkm-form-input
                                    label="Fim"
                                    type="date"
                                    v-model="model.dataFim"
                                    :validations="validations.dataFim"
                                />
                            </rkm-col>
                        </rkm-row>
                        
                        <rkm-row>
                            <rkm-col cols="auto">
                                <rkm-form-checkbox
                                    v-model="model.ativo"
                                    :label="false"
                                    inline
                                >
                                    Ativo
                                </rkm-form-checkbox>
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-area
                        no-margin-top
                        title="Pré-visualização"
                        type="fieldset"
                    >
                        <Preview :model="model" />
                    </rkm-area>
                </rkm-col>
            </rkm-row>
        </rkm-form>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

import { repository, stringCase, object, error } from '@/mixins'

import BannerIcone from './components/BannerIcone'
import Preview from './components/Preview'
import acaoBanners from '../../../enums/parametrizacao/acaoBanners';

export default {
    components: {
        BannerIcone,
        Preview,
    },
    computed: {
        acaoCodigo() {

            const acaoTipo = this.form.acaoTipos.find(item => item.id === this.model.bannerAcaoTipoId)

            return acaoTipo ? acaoTipo.codigo : null
        },
        validations() {

            return {
                titulo: { required: true, max: 40 },
                texto: { required: true, max: 90 },
                acaoTipo: { required: true },
                tela: { required: true },
                acaoUrl: { required: true, max: 500 },
                origem: { max: 100 },
                ordem: { required: true, min_value: 0 },
                dataInicio: { required: true },
                dataFim: { required: true },
            }
        },
    },
    created() {

        this.repositories = {
            banners: this.getConectaSusRepository('parametrizacao.banners'),
        }

        this.load()
    },
    data: () => ({
        acaoBanners,
        model: {},
        form: {},
        loaded: false,
        icones: [
            { id: 'needle', nome: 'Vacinação' },
            { id: 'calendar-clock', nome: 'Agendamento' },
            { id: 'flask', nome: 'Exames' },
            { id: 'clock-outline', nome: 'Horário' },
            { id: 'bullhorn', nome: 'Aviso' },
            { id: 'information-outline', nome: 'Informação' },
        ],
        cores: [
            { valor: '#1F8A4C', nome: 'Verde' },
            { valor: '#0A6CDB', nome: 'Azul' },
            { valor: '#5856D6', nome: 'Roxo' },
            { valor: '#C75A00', nome: 'Laranja' },
            { valor: '#C2185B', nome: 'Rosa' },
        ],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            const request = this.id
                ? this.repositories.banners.edit(this.id)
                : this.repositories.banners.create()

            request
                .then(({ data }) => {

                    this.form = data.form
                    this.model = Object.assign(
                        {
                            titulo: '',
                            texto: '',
                            icone: this.icones[0].id,
                            cor: this.cores[0].valor,
                            bannerAcaoTipoId: null,
                            parametrizacaoBannerTelaId: null,
                            acaoUrl: null,
                            origem: null,
                            ordem: 0,
                            dataInicio: null,
                            dataFim: null,
                            ativo: true,
                        },
                        data.model
                    )

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    const request = this.id
                        ? this.repositories.banners.update(this.id, this.prepareData())
                        : this.repositories.banners.store(this.prepareData())

                    request
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            const data = this.clone(this.model)

            if (data.parametrizacaoBannerAcaoTipoId !== acaoBanners.TELA_APP) {

                data.parametrizacaoBannerTelaId = null
            }

            if (data.parametrizacaoBannerAcaoTipoId !== acaoBanners.LINK) {

                data.acaoUrl = null
            }

            return this.camelObjectKeysToSnakeRecursive(data)
        },
    },
    mixins: [repository, stringCase, object, error],
    props: {
        id: { type: Number },
    },
}
</script>

<style scoped>
    .opcoes {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 8px;
        min-height: 44px;
    }
    .opcao-icone {
        display: flex;
        flex: 0 0 44px;
        align-items: center;
        justify-content: center;
        width: 44px;
        height: 44px;
        padding: 0;
        border: 1px solid #CED4DA;
        border-radius: 6px;
        background: #FFFFFF;
        color: #495057;
        cursor: pointer;
    }
    .opcao-icone.selecionado {
        border: 2px solid #007BFF;
        box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.2);
        color: #007BFF;
    }
    .opcao-cor {
        flex: 0 0 32px;
        width: 32px;
        height: 32px;
        padding: 0;
        border: 0;
        border-radius: 50%;
        cursor: pointer;
    }
    .opcao-cor.selecionado {
        box-shadow: 0 0 0 3px #FFFFFF, 0 0 0 5px #007BFF;
    }
</style>
